/**
 * When the Confirm button of the side-panel RelationshipRecordForm (add/edit an
 * object_template_attribute, role_permission, plugin_action, …) is disabled.
 *
 * A NEW record's Confirm stays disabled after a successful create so a second
 * click cannot create a duplicate while the panel closes. That rule must key off
 * a create that actually SUCCEEDED (`createSucceeded`), not final-form's
 * `submitSucceeded`: final-form sets `submitSucceeded = true` whenever the
 * onSubmit promise settles without submit errors — including when it REJECTS
 * (failed request, cancelled impact notice). Keying off it left Confirm disabled
 * for good after e.g. a "name already exists" error, so the user could not fix
 * the name and retry (operator-task-fe-attribute-create-duplicate-name-error-
 * confirm-stays-disabled).
 */
export interface RelationshipConfirmState {
    hasValidationErrors: boolean;
    /** True when the form creates a new record (no recordId). */
    isNew: boolean;
    pristine: boolean;
    submitting: boolean;
    /** True once the create request for a new record has succeeded. */
    createSucceeded: boolean;
    /** Edit forms: a field asked to enable Save although the form is pristine. */
    isSaveEnabledManually: boolean;
}

export const isRelationshipConfirmDisabled = ({
    hasValidationErrors,
    isNew,
    pristine,
    submitting,
    createSucceeded,
    isSaveEnabledManually,
}: RelationshipConfirmState): boolean =>
    hasValidationErrors ||
    submitting ||
    (isNew ? pristine || createSucceeded : pristine && !isSaveEnabledManually);
